import { ChangeDetectorRef, Component, effect, inject, signal, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { PayerSelectComponent } from '../../field-components/payer-select/payer-select.component';
import { UploadDateComponent } from '../../field-components/upload-date/upload-date.component';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { FileDataStore } from '../../../store/file-data.store';
import { PayerItem } from '../../../models/payer-item';
import { AsmFilesGridComponent } from './asm-files-grid/asm-files-grid.component';

@Component({
    selector: 'app-asm-files',
    imports: [
        MatButtonModule,
        UploadDateComponent,
        PayerSelectComponent,
        MatTooltipModule,
        MatIcon,
        AsmFilesGridComponent
    ],
    templateUrl: './asm-files.component.html',
    styleUrl: './asm-files.component.scss'
})
export class AsmFilesComponent {
  readonly mode = 'asm';
  form: FormGroup;
  generateEnabled: boolean = false;
  generateTooltip = 'Generate list of ASM Files';
  subs: Subscription[] = [];

  @ViewChild(UploadDateComponent) createDateComp?: UploadDateComponent;
  @ViewChild(PayerSelectComponent) payerSelectComp?: PayerSelectComponent;
  controlsValid?: string;
  
  createDateReady = signal<boolean>(false);
  payerSelectReady = signal<boolean>(false);
  
  readonly store = inject(FileDataStore);

  // Used to prevent circular logic on initial report generation
  initialLoadComplete = signal<boolean>(false);

  constructor(
    private fb: FormBuilder,
    private changeDetector: ChangeDetectorRef,
  ) {
    this.form = this.fb.group({});
    effect(() => {
      this.generateEnabled = this.store.asmFormValid();
    });
  }

  ngOnInit() {
    this.subs.push(this.form.statusChanges.subscribe((s) => {
      this.changeDetector.markForCheck();
      this.controlsValid = s;
    }));
  }

  handleCreateDateReady() {
    this.createDateReady.set(true);
    this.tryInitialLoad();
  }

  handleCreateDateValueChange(date: Date | null) {
    this.store.setThresholdDate(date, this.mode);
  }

  handlePayerFieldReady() {
    this.payerSelectReady.set(true);
    this.onPayersFieldReady();
    this.tryInitialLoad();
  }

  private tryInitialLoad() {
    if (!this.createDateReady() || !this.payerSelectReady() || this.initialLoadComplete()) {
      return;
    }

    setTimeout(() => {
      this.onGenerateReport();
    }, 300);
    this.initialLoadComplete.set(true);
  }

  onPayersFieldReady() {
    setTimeout(() => {
      this.payerSelectComp?.setSelectedValues([]);
    }, 200);

    // All selected by default, so set Payers list in state to all options.
    if (this.payerSelectComp?.options)
      this.store.setSelectedPayers(this.payerSelectComp?.options, this.mode);
  }

  handlePayerValueChange(event: PayerItem[]) {
    this.store.setSelectedPayers(event, this.mode);
  }

  onGenerateReport() {
    this.store.getAsmTableData();
  }

  ngOnDestroy() {
    this.subs.forEach((sub) => { sub.unsubscribe() });
  }
}
